module.exports = __webpack_public_path__ + "img/tarjeta-de-identificacion.09edd91b.png";